/**
 * Some useful mathematical functions.
 */

/**
 * Returns min, if x < min, else x.
 */
export function clampMin(x: number, min: number): number {
	return x < min ? min : x
}

/**
 * Returns max, if x > max, else x.
 */
export function clampMax(x: number, max: number): number {
	return x > max ? max : x
}

/**
 * Returns x, but not lower than min and not higher than max.
 */
export function clamp(x: number, min: number, max: number): number {
	return x < min ? min : (x > max ? max : x)
}


/**
 * Returns the greatest common divisor of the given numbers.
 */
export function gcd(n1: number, n2: number): number {
	if (n2 == 0)
		return n1;
	else
		return gcd(n2, n1 % n2);
}


// WEBPACK FOOTER //
// ./src/utils/math/math-utils.ts